module.exports = __webpack_public_path__ + "static/img/asistencia.63efc74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/asistencia.svg
// module id = azDp
// module chunks = 79